export const HEIC_IMAGE_FORMAT = 'image/heic';

export const HEIF_IMAGE_FORMAT = 'image/heif';

export const HEIC_MIME_TYPES = [HEIC_IMAGE_FORMAT, HEIF_IMAGE_FORMAT];

export const PNG_IMAGE_FORMAT = 'image/png';

export const JPEG_IMAGE_FORMAT = 'image/jpeg';
